import React from 'react';

const AlertTypeBadge = ({ label, className }) => (
  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${className}`}>
    {label}
  </span>
);

export default AlertTypeBadge;
